// extracted by mini-css-extract-plugin
export default {"container":"Events_container__QNl-R","row":"Events_row__577dS","col-md-3":"Events_col-md-3__fZ5Hd","imgFluid":"Events_imgFluid__ZN0rC","title":"Events_title__FBs4j"};